import ElectricBoltRoundedIcon from '@mui/icons-material/ElectricBoltRounded';
import HelpCenterRoundedIcon from '@mui/icons-material/HelpCenterRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import {
  Box,
  Container,
  Grid,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import { SectionTitleFontSize } from '../HomeView';

/**
 * The purpose of this section is to highlight some of the features built into the platform
 */
const PlatformFeaturesSection = () => {
  const iconSx: SxProps<Theme> = {
    fontSize: '4em',
    marginBottom: '.25em',
  };
  const itemSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  return (
    <Box
      sx={{
        color: 'white',
        backgroundColor: (t) => t.palette.primary.main,
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          fontWeight="bold"
          align="center"
          gutterBottom
          fontSize={SectionTitleFontSize}
        >
          Platform Features
        </Typography>
        <Grid container spacing={4} marginY="1em">
          <Grid item xs={12} sm={4} sx={itemSx}>
            <ElectricBoltRoundedIcon sx={iconSx} />
            <Typography variant="h6" align="center">
              Instant Setup
            </Typography>
            <Typography variant="body2" align="center">
              Get started immediately after purchase.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} sx={itemSx}>
            <ManageAccountsRoundedIcon sx={iconSx} />
            <Typography variant="h6" align="center">
              License Management
            </Typography>
            <Typography variant="body2" align="center">
              A streamlined dashboard for tracking employee progress.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} sx={itemSx}>
            <HelpCenterRoundedIcon sx={iconSx} />
            <Typography variant="h6" align="center">
              Direct Support
            </Typography>
            <Typography variant="body2" align="center">
              Personalized assistance every step of the way.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default PlatformFeaturesSection;
